const cadConfig = {
  locale: 'en-CA',
  formats: {
    number: {
      CAD: {
        style: 'currency',
        currency: 'CAD',
        currencyDisplay: 'code',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

export default cadConfig;
